import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState, AppDispatch } from "../../../app/store";
import { logError } from "../../../utils/utils";
import { kenngroesse, messstelle } from "../../../utils/apiTypes";
import { postJsonWithAuth } from "../../../utils/api";
import { anomalieDetailedTables, anomalieDetailWithMessstelleAndKenngroesse, anomalieDetailObject } from "./anomalieTypes";
import { errorHandler } from "../../../utils/errorHandling";


const initialState: anomalieDetailedTables = {
    anomalieDetailedList: [],
    isLoadingDetailedGrid: false,
}

// Slice 

const anomalieDetailedGridSlice = createSlice({
    name: "anomalieDetailedGrid",
    initialState,
    reducers: {
        setAnomalieDetailedList: (state, action: PayloadAction<{ anomalieDetailObjectParam: anomalieDetailObject[], messstelleParam2: string, kenngroesseParam2: string, isOldParam: boolean }>) => {
            const value: anomalieDetailWithMessstelleAndKenngroesse = {
                anomalieDetailedObject: action.payload.anomalieDetailObjectParam,
                messstelle: action.payload.messstelleParam2,
                kenngroesseKurzname: action.payload.kenngroesseParam2,
                isOld: action.payload.isOldParam
            }


            const recordExists = Boolean(state.anomalieDetailedList.find(e => e.messstelle + e.kenngroesseKurzname === action.payload.messstelleParam2 + action.payload.kenngroesseParam2));
            !recordExists && state.anomalieDetailedList.push(value);
        },
        setIsLoadingDetailedGrid: (state, action: PayloadAction<boolean>) => {
            state.isLoadingDetailedGrid = action.payload;
        },
        deleteAnomalieDetailedElem: (state, action: PayloadAction<anomalieDetailWithMessstelleAndKenngroesse>) => {

            for (let index = 0; index < state.anomalieDetailedList.length; index++) {
                // eslint-disable-next-line security/detect-object-injection
                const element = state.anomalieDetailedList[index];
                if (element.kenngroesseKurzname == action.payload.kenngroesseKurzname) {
                    state.anomalieDetailedList.splice(index, 1);
                }
            }
        },
        setIsOld: (state, action: PayloadAction<boolean>) => {
            state.anomalieDetailedList.forEach((el) => el.isOld = action.payload);
        }

    }
})

// Selectors

export const selectAnomalieDetailedList = (state: RootState): anomalieDetailWithMessstelleAndKenngroesse[] => state.anomalieDetailedGrid.anomalieDetailedList;
export const selectIsLoadingDetailedGrid = (state: RootState): boolean => state.anomalieDetailedGrid.isLoadingDetailedGrid;

// Actions

export const { setAnomalieDetailedList, setIsLoadingDetailedGrid, deleteAnomalieDetailedElem, setIsOld } = anomalieDetailedGridSlice.actions;

// Getter
export const getAnomalieDetail =
    (messstellenListeParam: Array<messstelle>, kenngroesseParam: Array<kenngroesse>, startParam: Date, endeParam: Date, anomalientypenParam: Array<string>, signifikanzParam: Array<string>, messstelleParam: string, kenngroessenkurznameParam: string) => (
        dispatch: AppDispatch): void => {

        const body = {
            start: startParam,
            end: endeParam,
            kenngroessen: kenngroesseParam,
            messstellen: messstellenListeParam,
            anomalietypen: anomalientypenParam,
            signifikanz: signifikanzParam,
        }

        const header = {
            messstelle: messstelleParam,
            kenngroessenkurzname: kenngroessenkurznameParam
        }

        dispatch(setIsLoadingDetailedGrid(true))

        postJsonWithAuth("ANOMALIEDETAILEDTABLE", header, body)
            .then((response: Array<anomalieDetailObject>) => {
                dispatch(setAnomalieDetailedList({
                    anomalieDetailObjectParam: response,
                    messstelleParam2: messstelleParam,
                    kenngroesseParam2: kenngroessenkurznameParam,
                    isOldParam: false,
                }))
            })
            .catch((error) => {
                logError(error);
                errorHandler(error, dispatch);
            }).finally(() => dispatch(setIsLoadingDetailedGrid(false)));

    };

export default anomalieDetailedGridSlice.reducer;